'use client';

import { useReportWebVitals } from 'next/web-vitals';

export default function WebVitals(): null {
  useReportWebVitals((metric) => {
    if (process.env.NEXT_PUBLIC_ENV === 'dev') {
      // eslint-disable-next-line no-console
      console.log(metric);
    }
    // Optionally, send metrics to an analytics endpoint
  });

  return null;
}
